import { render, staticRenderFns } from "./waterTankForm.vue?vue&type=template&id=d52db2d6&scoped=true&"
import script from "./waterTankForm.vue?vue&type=script&lang=ts&"
export * from "./waterTankForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52db2d6",
  null
  
)

export default component.exports